import { BannerSlider } from "@omni/components/components/BannerSlider/bannerSlider";
import { cn } from "@omni/utils/styles";

export const BannerSliderComponent = () => {
    return (
        <>
            <BannerSlider.Slider>
                <BannerSlider.Slider.NavButton
                    type={"left"}
                    className={cn("tw:left-8")}
                >
                    <i className={cn("las la-arrow-left")} />
                </BannerSlider.Slider.NavButton>
                <BannerSlider.Slider.Slides
                    className={cn("tw:rounded-xl tw:mb-4")}
                >
                    <BannerSlider.Slider.Slides.Slide />
                </BannerSlider.Slider.Slides>
                <BannerSlider.Slider.NavButton
                    type={"right"}
                    className={cn("tw:right-8")}
                >
                    <i className={cn("las la-arrow-right")} />
                </BannerSlider.Slider.NavButton>
            </BannerSlider.Slider>
            <BannerSlider.Controls>
                <BannerSlider.Controls.ProgressBar>
                    <BannerSlider.Controls.ProgressBar.Bar>
                        <BannerSlider.Controls.ProgressBar.Bar.Content />
                    </BannerSlider.Controls.ProgressBar.Bar>
                </BannerSlider.Controls.ProgressBar>
                <BannerSlider.Controls.Button
                    className={cn("tw:h-8 tw:w-8 tw:p-0")}
                />
            </BannerSlider.Controls>
        </>
    );
};
